import React from "react";
import { useNavigate } from "react-router-dom";

const HeroSection = ({ setShowLoginPopup }) => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    setShowLoginPopup(true); // Open the login popup
  };

  return (
    <section className="relative min-h-[80vh] md:min-h-screen flex items-center justify-center text-white overflow-hidden">
      {/* Video Background */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover z-0"
      >
        <source src="/videos/hero-video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-40 z-10"></div>

      {/* Content */}
      <div className="relative z-20 text-center max-w-4xl px-4 sm:px-6 md:px-8">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6">
          Reach Your Dance Goals
        </h1>
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-6 sm:mb-8">
          With 1500+ online classes, programs, and more.
        </p>
        <button
          onClick={handleGetStarted}
          className="px-5 sm:px-6 md:px-8 py-2 sm:py-3 text-sm sm:text-base md:text-lg font-semibold bg-gradient-to-r from-purple-500 to-pink-500 rounded-full hover:from-pink-500 hover:to-purple-500 transition-all shadow-lg"
        >
          Get Started
        </button>
      </div>

      {/* Scrolling Indicator */}
      <div className="absolute bottom-6 sm:bottom-8 md:bottom-12 left-1/2 transform -translate-x-1/2 z-20 animate-bounce">
        <svg
          className="w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 14l-7 7m0 0l-7-7m7 7V3"
          ></path>
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;

